import { ShieldCheck } from 'lucide-react';

const LOGO_SRC = '/branding/logo-jobkongo.png';

/**
 * Brand logo for Job Kongo.
 * - `size`: sm | md | lg | xl (controls image height)
 * - `variant`: 'default' (image only) | 'with-text' (image + wordmark text)
 * - `onDark`: subtle treatment when used on dark backgrounds (footer, hero overlays)
 * - `showTagline`: shows "Mosala na confiance" below
 */
export const Logo = ({
  size = 'md',
  variant = 'default',
  onDark = false,
  showTagline = false,
  className = '',
}) => {
  const dim = size === 'xs' ? 28 : size === 'sm' ? 36 : size === 'lg' ? 56 : size === 'xl' ? 88 : 44;
  const nameSize = size === 'xs' ? 'text-base' : size === 'sm' ? 'text-lg' : size === 'lg' ? 'text-2xl' : size === 'xl' ? 'text-3xl' : 'text-xl';
  const taglineColor = onDark ? 'text-[#FFE36B]' : 'text-[#16764A]';
  const wordColor = onDark ? 'text-white' : 'text-[#0E3F80]';
  const wordAccent = onDark ? 'text-[#F7D618]' : 'text-[#1677F2]';

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src={LOGO_SRC}
        alt="Job Kongo"
        width={dim}
        height={dim}
        className="object-contain flex-shrink-0 select-none"
        style={{ height: dim, width: dim }}
        draggable={false}
      />
      {(variant === 'with-text' || showTagline) && (
        <div className="flex flex-col leading-tight">
          {variant === 'with-text' && (
            <span
              className={`${nameSize} font-bold tracking-tight ${wordColor}`}
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Job<span className={wordAccent}>Kongo</span>
            </span>
          )}
          {showTagline && (
            <span className={`text-[11px] ${taglineColor} font-medium flex items-center gap-1`}>
              <ShieldCheck size={12} /> Mosala na confiance
            </span>
          )}
        </div>
      )}
    </div>
  );
};
